(() => {
    'use strict';
    const translations = {
      en: {
        eyebrow: 'THE WHOLESALE AI AGENT', headline1: 'Wholesale deals.', headline2: 'Connected.',
        description: 'Deallo connects buyers, sellers, and inventory through WhatsApp and email. Link your accounts and turn more conversations into wholesale deals.',
        cta: 'Get Started', login: 'Log in', helper: "Connect WhatsApp & email. That’s it.",
        metricDeals: 'Live Deals', metricDealsSub: 'Active inventory opportunities',
        metricBuyers: 'Buyer Network', metricBuyersSub: 'Verified wholesale buyers',
        metricCountries: 'Global Countries', metricCountriesSub: 'Cross-border market reach',
        metricRevenue: 'Invoice Revenue', metricRevenueSub: 'Total invoice value transacted',
        inventory: 'INVENTORY', buyers: 'BUYER NEEDS', matched: 'MATCHED DEALS',
        modalTitle: 'One connection. More deals.', modalDesc: 'Start with your work email. Then connect the channels where your wholesale business already happens.',
        emailLabel: 'Work email', continue: 'Continue', demoNotice: 'Interactive website preview. Sign-up is not connected to a server.',
        nextTitle: "You're ready to connect.", nextDesc: 'In the real product, your next step is to connect WhatsApp and email so Deallo can work across your wholesale conversations.', demoOnly: 'Demo only'
      },
      es: {
        eyebrow: 'TU AGENTE DE IA PARA MAYOREO', headline1: 'Negocios mayoristas.', headline2: 'Conectados.',
        description: 'Deallo conecta compradores, vendedores e inventario por WhatsApp y correo electrónico. Conecta tus cuentas y convierte más conversaciones en negocios.',
        cta: 'Comenzar', login: 'Iniciar sesión', helper: 'Conecta WhatsApp y correo. Así de fácil.',
        metricDeals: 'Operaciones activas', metricDealsSub: 'Oportunidades de inventario activas',
        metricBuyers: 'Red de compradores', metricBuyersSub: 'Compradores mayoristas verificados',
        metricCountries: 'Países globales', metricCountriesSub: 'Alcance de mercado internacional',
        metricRevenue: 'Ingresos facturados', metricRevenueSub: 'Valor total facturado',
        inventory: 'INVENTARIO', buyers: 'NECESIDADES DE COMPRA', matched: 'NEGOCIOS CONECTADOS',
        modalTitle: 'Una conexión. Más negocios.', modalDesc: 'Empieza con tu correo de trabajo y conecta tus canales de ventas mayoristas.',
        emailLabel: 'Correo de trabajo', continue: 'Continuar', demoNotice: 'Vista previa interactiva. El registro todavía no está conectado a un servidor.',
        nextTitle: 'Todo listo para conectar.', nextDesc: 'En el producto real, conecta WhatsApp y correo para que Deallo pueda ayudarte con tus conversaciones mayoristas.', demoOnly: 'Solo demo'
      },
      ar: {
        eyebrow: 'وكيل الذكاء الاصطناعي لتجارة الجملة', headline1: 'صفقات الجملة.', headline2: 'مترابطة.',
        description: 'يربط Deallo المشترين والبائعين والمخزون عبر واتساب والبريد الإلكتروني. اربط حساباتك وحوّل المزيد من المحادثات إلى صفقات.',
        cta: 'ابدأ الآن', login: 'تسجيل الدخول', helper: 'اربط واتساب والبريد الإلكتروني. هذا كل شيء.',
        metricDeals: 'الصفقات النشطة', metricDealsSub: 'فرص مخزون نشطة',
        metricBuyers: 'شبكة المشترين', metricBuyersSub: 'مشترون بالجملة تم التحقق منهم',
        metricCountries: 'دول حول العالم', metricCountriesSub: 'وصول إلى أسواق متعددة',
        metricRevenue: 'إيرادات الفواتير', metricRevenueSub: 'إجمالي قيمة الفواتير المنفذة',
        inventory: 'المخزون', buyers: 'طلبات المشترين', matched: 'صفقات متطابقة',
        modalTitle: 'اتصال واحد. صفقات أكثر.', modalDesc: 'ابدأ ببريد العمل، ثم اربط قنوات التواصل التي تستخدمها في تجارة الجملة.',
        emailLabel: 'البريد الإلكتروني للعمل', continue: 'متابعة', demoNotice: 'هذه نسخة تفاعلية تجريبية. التسجيل غير متصل بالخادم.',
        nextTitle: 'أنت جاهز للربط.', nextDesc: 'في المنتج الفعلي، ستربط واتساب والبريد الإلكتروني ليعمل Deallo مع محادثات الجملة الخاصة بك.', demoOnly: 'تجريبي فقط'
      },
      zh: {
        eyebrow: '您的批发 AI 智能代理', headline1: '全球批发商机。', headline2: '智能连接。',
        description: 'Deallo 通过 WhatsApp 和电子邮件连接买家、卖家与库存。只需连接账户，让更多对话转化为实际交易。',
        cta: '立即开始', login: '登录', helper: '连接 WhatsApp 和邮箱，即刻开始。',
        metricDeals: '实时交易', metricDealsSub: '当前活跃库存机会',
        metricBuyers: '买家网络', metricBuyersSub: '已验证批发买家',
        metricCountries: '覆盖国家', metricCountriesSub: '全球跨境市场触达',
        metricRevenue: '累计发票金额', metricRevenueSub: '已成交总发票价值',
        inventory: '可售库存', buyers: '买家需求', matched: '成功匹配',
        modalTitle: '一次连接，更多交易。', modalDesc: '输入工作邮箱，随后连接您日常进行批发业务的沟通渠道。',
        emailLabel: '工作邮箱', continue: '继续', demoNotice: '这是交互式网站预览，尚未接入真实注册服务。',
        nextTitle: '已准备好连接。', nextDesc: '正式产品中，下一步将连接 WhatsApp 和邮箱，让 Deallo 协助处理您的批发业务沟通。', demoOnly: '仅供演示'
      }
    };
    let currentLanguage = 'en';
    const heroCopy = document.getElementById('hero-copy');
    function selectLanguage(key) {
      const lang = translations[key]; if (!lang) return;
      currentLanguage = key;
      document.querySelector('.site').dataset.locale = key;
      document.documentElement.lang = key === 'zh' ? 'zh-CN' : key;
      document.querySelectorAll('[data-copy]').forEach(el => { const value = lang[el.dataset.copy]; if (value) el.textContent = value; });
      document.querySelectorAll('.lang').forEach(el => { el.setAttribute('aria-pressed', String(el.dataset.lang === key)); });
      heroCopy.dir = key === 'ar' ? 'rtl' : 'ltr';
      document.getElementById('dialog').dir = key === 'ar' ? 'rtl' : 'ltr';
      document.title = 'Deallo — ' + lang.headline1 + ' ' + lang.headline2;
    }
    document.querySelectorAll('.lang').forEach(btn => btn.addEventListener('click', () => selectLanguage(btn.dataset.lang)));

    function formatCounterValue(value, el) {
      const prefix = el.dataset.prefix || '';
      const suffix = el.dataset.suffix || '';
      const format = el.dataset.format || 'integer';
      let out = value;
      if (format === 'integer') out = Math.round(value).toLocaleString('en-US');
      return prefix + out + suffix;
    }
    function runCounters() {
      const counters = [...document.querySelectorAll('[data-counter]')];
      const start = performance.now();
      const duration = 1500;
      function tick(now) {
        const progress = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        counters.forEach(el => {
          const target = Number(el.dataset.target || 0);
          const current = target * eased;
          el.textContent = formatCounterValue(current, el);
        });
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    if (document.querySelector('[data-counter]')) runCounters();
    // Lightweight generative visual of a wholesale trading network.
    // Dozens of buyer/seller opportunities are connected by gently moving signals.
    const canvas = document.getElementById('deal-network');
    if (!canvas) return;
    const stage = canvas.parentElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    let width = 0, height = 0, nodes = [], links = [], particles = [], center = { x: 0, y: 0 };
    let raf = 0, lastDraw = 0;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const makeRandom = (seed) => () => { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296; };
    function bezierPoint(p, t) {
      const m = 1 - t;
      return {
        x: m*m*m*p[0].x + 3*m*m*t*p[1].x + 3*m*t*t*p[2].x + t*t*t*p[3].x,
        y: m*m*m*p[0].y + 3*m*m*t*p[1].y + 3*m*t*t*p[2].y + t*t*t*p[3].y
      };
    }
    function build() {
      width = stage.clientWidth; height = stage.clientHeight;
      const dpr = Math.min(devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, Math.round(width * dpr));
      canvas.height = Math.max(1, Math.round(height * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const rand = makeRandom(417);
      const cx = width * .55, cy = height * .515;
      const rx = width * .39, ry = Math.min(height * .392, width * .43);
      center = { x: cx, y: cy };
      const left = [], right = [];
      for (let i = 0; i < 38; i++) {
        const a = Math.PI * (.55 + (i / 37) * .90);
        const r = .65 + rand() * .33;
        left.push({ x: cx + Math.cos(a) * rx * r, y: cy + Math.sin(a) * ry * r, size: .9 + rand() * 1.65, phase: rand() });
      }
      for (let i = 0; i < 38; i++) {
        const a = Math.PI * (-.47 + (i / 37) * .94);
        const r = .65 + rand() * .33;
        right.push({ x: cx + Math.cos(a) * rx * r, y: cy + Math.sin(a) * ry * r, size: .9 + rand() * 1.65, phase: rand() });
      }
      nodes = [...left, ...right];
      for (let i = 0; i < 34; i++) {
        const a = rand() * Math.PI * 2;
        const r = Math.sqrt(rand()) * .9;
        nodes.push({ x: cx + Math.cos(a) * rx * r, y: cy + Math.sin(a) * ry * r, size: .6 + rand() * 1.2, phase: rand() });
      }
      links = [];
      for (let i = 0; i < 65; i++) {
        const a = left[Math.floor(rand() * left.length)];
        const b = right[Math.floor(rand() * right.length)];
        const lift = (rand() - .5) * height * .46;
        const path = [a,
          { x: a.x + (b.x - a.x) * .37, y: a.y + lift },
          { x: b.x - (b.x - a.x) * .37, y: b.y - lift }, b];
        links.push({ path, active: i % 8 === 2, phase: rand(), speed: .000035 + rand() * .000035 });
      }
      particles = Array.from({ length: 80 }, () => ({
        x: width * (.09 + rand() * .85), y: height * (.11 + rand() * .81),
        size: .3 + rand() * .8, alpha: .03 + rand() * .13
      }));
    }
    function draw(t) {
      ctx.clearRect(0, 0, width, height);
      const cx = center.x, cy = center.y;
      // One restrained ambient halo, not a literal globe illustration.
      const aura = ctx.createRadialGradient(cx, cy, 0, cx, cy, Math.min(width, height) * .48);
      aura.addColorStop(0, 'rgba(19, 101, 120, .075)');
      aura.addColorStop(.37, 'rgba(23, 63, 132, .065)');
      aura.addColorStop(1, 'rgba(12, 20, 59, 0)');
      ctx.fillStyle = aura;
      ctx.beginPath(); ctx.arc(cx, cy, Math.min(width, height) * .48, 0, Math.PI * 2); ctx.fill();
      // A few delicate ellipse orbits create depth around the deal web.
      ctx.save();
      ctx.translate(cx, cy);
      [[.46, .37, -.32, .08], [.40, .30, .66, .12], [.37, .42, 1.28, .08]].forEach(v => {
        ctx.beginPath(); ctx.ellipse(0, 0, width * v[0], height * v[1], v[2], 0, Math.PI * 2);
        ctx.lineWidth = .9; ctx.strokeStyle = 'rgba(110, 159, 255,' + v[3] + ')'; ctx.stroke();
      });
      ctx.restore();
      particles.forEach(p => {
        ctx.beginPath(); ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(162,194,255,' + p.alpha + ')'; ctx.fill();
      });
      // Connections: many potential deals, a select few successful green links.
      links.forEach((link, i) => {
        const p = link.path;
        ctx.beginPath(); ctx.moveTo(p[0].x, p[0].y);
        ctx.bezierCurveTo(p[1].x, p[1].y, p[2].x, p[2].y, p[3].x, p[3].y);
        ctx.lineWidth = link.active ? 1.05 : .65;
        ctx.strokeStyle = link.active ? 'rgba(101,246,174,.30)' : 'rgba(116,166,255,.145)';
        ctx.stroke();
        if ((i % 3 === 0 || link.active)) {
          const n = reducedMotion.matches ? link.phase : (t * link.speed + link.phase) % 1;
          const here = bezierPoint(p, n);
          const prev = bezierPoint(p, Math.max(0, n - .021));
          ctx.beginPath(); ctx.moveTo(prev.x, prev.y); ctx.lineTo(here.x, here.y);
          ctx.lineWidth = link.active ? 1.6 : 1.2;
          ctx.strokeStyle = link.active ? 'rgba(117,255,186,.84)' : 'rgba(137,192,255,.59)';
          ctx.stroke();
          ctx.save();
          ctx.shadowBlur = link.active ? 19 : 10;
          ctx.shadowColor = link.active ? '#5df6ab' : '#7fafff';
          ctx.beginPath(); ctx.arc(here.x, here.y, link.active ? 2 : 1.45, 0, Math.PI * 2);
          ctx.fillStyle = link.active ? '#b8ffda' : '#a6ccff'; ctx.fill();
          ctx.restore();
        }
      });
      nodes.forEach((p, i) => {
        const featured = i % 11 === 0;
        ctx.save();
        if (featured) { ctx.shadowBlur = 14; ctx.shadowColor = '#6affb6'; }
        ctx.beginPath(); ctx.arc(p.x, p.y, featured ? p.size + .25 : p.size, 0, Math.PI * 2);
        ctx.fillStyle = featured ? 'rgba(110,255,186,.91)' : 'rgba(158,196,255,.62)';
        ctx.fill();
        ctx.restore();
        if (featured) {
          ctx.beginPath(); ctx.arc(p.x, p.y, p.size + 5, 0, Math.PI * 2);
          ctx.strokeStyle = 'rgba(110,255,186,.20)'; ctx.lineWidth = 1; ctx.stroke();
        }
      });
      // Small single Deallo connection hub; avoids dashboard-style floating cards.
      const glow = ctx.createRadialGradient(cx, cy, 0, cx, cy, 69);
      glow.addColorStop(0, 'rgba(80,250,165,.20)'); glow.addColorStop(1, 'rgba(80,250,165,0)');
      ctx.fillStyle = glow; ctx.beginPath(); ctx.arc(cx, cy, 69, 0, 2 * Math.PI); ctx.fill();
      ctx.save(); ctx.shadowBlur = 23; ctx.shadowColor = '#64f8aa';
      ctx.strokeStyle = 'rgba(115,255,184,.78)'; ctx.lineWidth = 1.1;
      ctx.beginPath(); ctx.arc(cx, cy, 25, 0, Math.PI * 2); ctx.stroke();
      ctx.restore();
      ctx.fillStyle = '#89ffc8';
      [[-7,0],[7,0],[0,-7],[0,7]].forEach(([x,y]) => {ctx.beginPath();ctx.arc(cx+x,cy+y,2.2,0,2*Math.PI);ctx.fill();});
      ctx.strokeStyle = 'rgba(137,255,202,.85)'; ctx.lineWidth = 1.2;
      ctx.beginPath();ctx.moveTo(cx-7,cy);ctx.lineTo(cx+7,cy);ctx.moveTo(cx,cy-7);ctx.lineTo(cx,cy+7);ctx.stroke();
    }
    function frame(t) {
      if (t - lastDraw > 28) { draw(t); lastDraw = t; }
      if (!reducedMotion.matches) raf = requestAnimationFrame(frame);
    }
    function resize() {
      if (raf) cancelAnimationFrame(raf);
      build(); draw(0); lastDraw = 0;
      if (!reducedMotion.matches) raf = requestAnimationFrame(frame);
    }
    const ro = new ResizeObserver(resize);
    ro.observe(stage);
    reducedMotion.addEventListener('change', resize);
    resize();
  })();
